var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState, useCallback } from "react";
import { useDispatch } from "react-redux";
import LocalStorageService from "../../services/localStorage";
import { useUserGetAll } from "../../fnx/user/userGetAll";
import { typeAlert, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import showToast from "../../services/toast";
import { AlertLoadingHeader } from "../../components/alertLoadingComponent/alertLoading";
import { UserView } from "./ui/viewV2";
import { useCreateUserForm } from "./hooks/useCreateUser";
import logoAffinity from "../../assets/images/logoAffinity.svg";
import { paginationAFYProps, searchFiltersBarProps, userCardAddNewProps, cardContextMenuAFYProps, createUserProps, drawerProps, stepsProps, viewTypeAfyProps, } from "./data";
import { useRoleUser } from "./hooks/useRoleUser";
import { useFilters } from "./hooks/useFilters";
import { useClickMenu } from "./hooks/useClickMenu";
import { useInputSearch } from "./hooks/useInputSearch";
import { useDeleteUser } from "./hooks/useDeleteUser";
import { ModalDelete } from "../user/resources/modalDelete";
var storageKey2 = "assurehub";
var lsLogin = new LocalStorageService(storageKey2);
export var UserAdminV2 = function () {
    var _a;
    var dispatch = useDispatch();
    var _b = useState([]), list = _b[0], setList = _b[1];
    var _c = useState(false), loadingPage = _c[0], setLoadingPage = _c[1];
    var _d = useState(""), loadingMessage = _d[0], setLoadingMessage = _d[1];
    var _e = useState(true), trigger = _e[0], setTrigger = _e[1];
    var clientId = React.useState(lsLogin.getUserLoginStored().clientId)[0];
    var branchId = React.useState(lsLogin.getUserLoginStored().branchId)[0];
    var _f = useState(1), page = _f[0], setPage = _f[1];
    var _g = useState(20), limit = _g[0], setLimit = _g[1];
    var _h = useState({
        show: false,
        message: "",
        type: typeAlert.success,
    }), seeToast = _h[0], setSeeToast = _h[1];
    //custom hooks
    var useCreateForms = useCreateUserForm(setSeeToast);
    var useRoleUsers = useRoleUser(setSeeToast, setTrigger);
    var useFiltersUsers = useFilters();
    var useClickMenus = useClickMenu();
    var useDeleteUsers = useDeleteUser();
    var handleSearchChange = useCallback(function (value) {
        setTrigger(true);
    }, []);
    var useInputSearchHook = useInputSearch(handleSearchChange);
    // Pagination handlers
    var handleChangePage = useCallback(function (newPage) {
        setPage(newPage);
        setTrigger(true);
    }, []);
    var handleChangeRowsPerPage = useCallback(function (newLimit) {
        setLimit(newLimit);
        setPage(1); // Reset to first page when changing rows per page
        setTrigger(true);
    }, []);
    var _j = useUserGetAll(trigger, '', page, limit, useInputSearchHook.debouncedValue), responseUser = _j.responseUser, errorUser = _j.errorUser, loadingUser = _j.loadingUser, pagingInfo = _j.pagingInfo;
    useEffect(function () {
        if (responseUser) {
            var list_1 = responseUser.map(function (item) { return (__assign(__assign({}, item), { status: item.enabled ? "Activo" : "Inactivo" })); });
            setList(list_1);
            setPage(pagingInfo.page);
            setLimit(pagingInfo.limit);
        }
        setTrigger(false);
    }, [responseUser, pagingInfo]);
    var handleEditUser = function (user) {
        console.log("user", user);
        var userInterface = {
            id: user.id || "",
            name: user.name || "",
            lastName: user.lastName || "",
            email: user.email || "",
            userName: user.userName || "",
            avatarUrl: user.avatarUrl || "",
            enabled: user.enabled || false,
            branchId: user.branchId || "",
            clientId: user.clientId || "",
            createdAt: "",
            deleted: false,
            disabledReason: "",
            lastLoginAt: "",
            loginAttempts: 0,
            roles: [],
        };
        useCreateForms.setSelectedUser(userInterface);
        useCreateForms.setOpenDrawer(true);
    };
    var drawerRolesListProps = {
        openDrawer: useRoleUsers.openDrawerRoles,
        view: 1,
        BgBackdrop: "transparent",
        BgcCloseButton: "#fff",
        colorIcon: "#000",
        bgColorDrawer: "#fff",
        customHeight: "40vh",
        img: logoAffinity,
        title: "Permisos",
        text: "",
        onValueApply: function () { },
        onClose: function () {
            useRoleUsers.setOpenDrawerRoles(false);
        },
        paginationProps: {
            count: 10,
            pagePagination: 1,
            rowsPerPages: 10,
            onChangePage: function () { },
            onChangeRowsPerPage: function () { },
            rowsPerPageOptions: [5, 10, 25],
        },
        onClickEdit: function () {
            useRoleUsers.setOpenDrawerRoles(false);
            useRoleUsers.setOpenDrawerRolesEdit(true);
        },
        data: useRoleUsers.rolsSelected,
        columns: [
            {
                field: "name",
                headerName: "Nombre",
            },
            {
                field: "description",
                headerName: "Descripcion",
            },
        ],
    };
    var drawerRolesEditProps = {
        open: useRoleUsers.openDrawerRolesEdit,
        onClose: function () {
            useRoleUsers.setOpenDrawerRolesEdit(false);
        },
        onRoleMove: useRoleUsers.onRoleMove,
        onRoleDelete: useRoleUsers.onRoleDelete,
        availableItems: useRoleUsers.availableItems,
        assignedItems: useRoleUsers.assignedItems,
        onSave: useRoleUsers.onSaveRolPermissions,
        title: "Asignar rol: ".concat((_a = useRoleUsers.selectedUser) === null || _a === void 0 ? void 0 : _a.name),
        subtitle: "Arrastra los roles disponibles hacia el cuadrante de Roles Asignados para asignar uno",
        availableTitle: "Roles Disponibles",
        assignedTitle: "Roles Asignados",
        availablePlaceholder: "Buscar Rol",
        assignedPlaceholder: "Buscar Rol",
        availableSearch: useRoleUsers.availableSearch,
        assignedSearch: useRoleUsers.assignedSearch,
        onAvailableSearchChange: useRoleUsers.onAvailableSearchChange,
        onAssignedSearchChange: useRoleUsers.onAssignedSearchChange,
        filteredAvailable: useRoleUsers.availableItemsFiltered,
        filteredAssigned: useRoleUsers.assignedItemsFiltered,
        textCancelButton: "Cancelar",
        textSaveButton: "Asignar Roles",
    };
    var dataUsers = {
        viewTypeAfyProps: viewTypeAfyProps,
        paginationAFYProps: __assign(__assign({}, paginationAFYProps), { countPagination: (pagingInfo === null || pagingInfo === void 0 ? void 0 : pagingInfo.totalItems) || 0, pagePagination: page, rowsPerPage: limit, onChangePage: handleChangePage, onChangeRowsPerPage: handleChangeRowsPerPage }),
        drawerRolesListProps: drawerRolesListProps,
        drawerRolesEditProps: drawerRolesEditProps,
        searchFiltersBarProps: __assign(__assign({}, searchFiltersBarProps), { term: useInputSearchHook.searchValue, showSearch: useFiltersUsers.showSearch, setShowSearch: useFiltersUsers.handleShowSearch, closeSearch: useFiltersUsers.handleShowSearch, clearFilter: useFiltersUsers.clearFilters, inputSearchConfig: useInputSearchHook.inputSearchConfig, filters: [
                {
                    id: "rol",
                    label: "Rol",
                    list: useRoleUsers.rolList,
                    defaultCheckedItems: useFiltersUsers.defaultCheckedItemsRol,
                    onSelect: useFiltersUsers.handleRolFilter,
                },
                {
                    id: "branch",
                    label: "Sucursal",
                    list: useCreateForms.branchOptions,
                    defaultCheckedItems: useFiltersUsers.defaultCheckedItemsBranch,
                    onSelect: useFiltersUsers.handleBranchFilter,
                },
                {
                    id: "status",
                    label: "Estado",
                    list: [
                        {
                            id: "true",
                            name: "Activo",
                            value: "true",
                        },
                        {
                            id: "false",
                            name: "Inactivo",
                            value: "false",
                        },
                    ],
                    defaultCheckedItems: useFiltersUsers.defaultCheckedItemsActive,
                    onSelect: useFiltersUsers.handleActiveFilter,
                },
            ] }),
        userCardAddNewProps: __assign(__assign({}, userCardAddNewProps), { onClickAdd: function () { return useCreateForms.setOpenDrawer(true); } }),
        cardContextMenuAFYProps: __assign(__assign({}, cardContextMenuAFYProps), { onClickContextMenu: function (menuItem, options) {
                console.log("menuItem", menuItem);
                switch (menuItem.id) {
                    case "1":
                        var selectedUser = list.find(function (user) { return user.id === options.id; });
                        console.log("selectedUser", selectedUser);
                        if (selectedUser) {
                            handleEditUser(selectedUser);
                        }
                        break;
                    case "2":
                        console.log("options 2", options);
                        useDeleteUsers.setOpenModalDelete(true);
                        useDeleteUsers.setModalTitle("¿Estás seguro de querer eliminar este usuario?");
                        break;
                    case "4":
                        console.log("options 4", options);
                        useRoleUsers.setOpenDrawerRoles(true);
                        useRoleUsers.setSelectedUser(options);
                        break;
                }
                // useClickMenus.handleClickMenu(menuItem, options);
            } }),
        createUserProps: __assign(__assign({}, createUserProps), { onSubmit: useCreateForms.onSubmit, idTypeOptions: useCreateForms.idTypeOptions, genderOptions: useCreateForms.genderOptions, companyOptions: useCreateForms.companyOptions, branchOptions: useCreateForms.branchOptions, intermediaryOptions: useCreateForms.intermediaryOptions, formCreateUser: useCreateForms.formCreateUser }),
        drawerProps: __assign(__assign({}, drawerProps), { openDrawer: useCreateForms.openDrawer, onClose: function () {
                useCreateForms.setOpenDrawer(false);
                useCreateForms.setSelectedUser(null);
            }, title: useCreateForms.isEditing ? "Editar usuario" : "Crear usuario", subTitle: useCreateForms.isEditing
                ? "Edita la información del usuario"
                : "Crea un nuevo usuario para tu sistema", titleButton: useCreateForms.isEditing ? "Actualizar" : "Crear", onValueApply: useCreateForms.onSubmit }),
        stepsProps: stepsProps,
        data: list,
        showPagination: true,
        columnsTable: [
            {
                field: "name",
                headerName: "Nombre",
                width: 150,
            },
            {
                field: "lastName",
                headerName: "Apellido",
                width: 150,
            },
            {
                field: "email",
                headerName: "Email",
                width: 150,
            },
            {
                field: "status",
                headerName: "Estado",
                width: 150,
            },
        ],
    };
    return (_jsxs(React.Fragment, { children: [_jsx(ModalDelete, { openModalConfirmDelete: useDeleteUsers.openModalDelete, setOpenModalDelete: useDeleteUsers.setOpenModalDelete, modalTitle: "¿Estás seguro de querer eliminar este usuario?", onClickDelete: useDeleteUsers.onSubmit }), _jsx(AlertLoadingHeader, { loading: loadingPage ||
                    loadingUser ||
                    useCreateForms.loadingCreateUser ||
                    useRoleUsers.loadingSaveRolPermissions, seeToast: seeToast, showToast: showToast, setSeeToast: setSeeToast, titleLoading: loadingMessage }), _jsx(UserView, __assign({}, dataUsers))] }));
};
